<div #cardParent class="expandable-card-parent">
  <div
    class="card-backdrop"
    [@transitionBackdrop]="expandState"
    (click)="backdropClick.emit()"
  ></div>
  <div
    class="scroll-wrapper"
    #scrollWrapper
    (click)="backdropClick.emit()"
    [class.pg-elevation-1]="!this.expanded"
    (scroll)="handleCardScroll($event)"
  >
    <pg-card
      class="expandable-card"
      [class.expanded]="this.expanded"
      (click)="handleCardClick($event)"
      [elevation]="this.elevation"
      [style.cursor]="this.expanded ? 'default' : 'pointer'"
      #card
    >
      <div
        class="card-content-wrapper"
        #content
        [style.top.px]="this.stickyHeaderTop"
      >
        <ng-content select="[visibleContent]"></ng-content>
      </div>
      <div class="card-expanded-content-wrapper" #expandContent>
        <ng-content></ng-content>
      </div>
    </pg-card>
  </div>
</div>
<div #cardPlaceholder></div>
